import {
    getPropertyVerifyLists,
    updatePropertyVerify,
    getPropertyVerifyMessages,
    createPropertyVerifyMessage,
    getAllPropertyVerifyLists
} from '../../../services/PropertyVerificationService';
import {
    CONFIRMED_GET_PROERTY_VERIFY_LISTS,
    CONFIRMED_GET_PROERTY_VERIFY_MESSAGES
} from './PropertyVerificationTypes';

export function getPropertyVerifyListsAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_PROPERTY_VERIFICATION_LOADING', payload: true });
        getPropertyVerifyLists(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetPropertyVerifyListsAction(response.data.data));
            })
            .catch(() => {
                dispatch(confirmedGetPropertyVerifyListsAction({ rows: [], count: 0, pages: 1 }));
            })
            .finally(() => {
                dispatch({ type: 'SET_PROPERTY_VERIFICATION_LOADING', payload: false });
            });
    };
}

export function getAllPropertyVerifyListsAction(filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_PROPERTY_VERIFICATION_LOADING', payload: true });
        getAllPropertyVerifyLists(filterQuery).then((response) => {
            dispatch(confirmedGetPropertyVerifyListsAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_PROPERTY_VERIFICATION_LOADING', payload: false });
        });
    };
}

export function confirmedGetPropertyVerifyListsAction(data) {
    return {
        type: CONFIRMED_GET_PROERTY_VERIFY_LISTS,
        payload: data,
    };
}

export function updatePropertyVerifyAction(id, data) {
    return () => {
        return updatePropertyVerify(id, data).then((response) => {
            return response;
        });
    };
}

export function getPropertyVerifyMessagessAction(filterQuery, refreshList = true) {
    
    return (dispatch, getState) => {
        if(refreshList)
            dispatch(confirmedGetPropertyVerifyMessagesAction([]));
        getPropertyVerifyMessages(filterQuery).then((response) => {
            dispatch(confirmedGetPropertyVerifyMessagesAction(response.data.data));
        });
    };
}

export function confirmedGetPropertyVerifyMessagesAction(data) {
    return {
        type: CONFIRMED_GET_PROERTY_VERIFY_MESSAGES,
        payload: data,
    };
}

export function createPropertyVerifyMessageAction(data) {
    return () => {
        return createPropertyVerifyMessage(data).then((response) => {
            return response;
        });
    };
}



